import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import ViewableTailoringCondition = stages.process.ViewableTailoringCondition;
@Component({
	selector: "stages-tailoring-conditions",
	templateUrl: "./tailoring-conditions.component.html",
	styleUrls: ["./tailoring-conditions.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TailoringConditionsComponent {
	@Input() translateNone?: string;

	@Input()
	tailoringConditions!: ViewableTailoringCondition[];
}
